import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { Reviews } from "@/components/Reviews";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  useLenis();
  return (
    <main data-testid="home-page" className="bg-ink">
      <Navbar />
      <Hero />
      <Services />
      <MarqueeStrip />
      <Reviews />
      <BookingSection />
      <Footer />
    </main>
  );
}
